import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "scale", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import iconMap from 'components/icons/iconMap';
import { jsx as _jsx } from "react/jsx-runtime";
var sizeMap = {
  unscaled: 0,
  default: 1,
  medium: 1.5,
  big: 3,
  huge: 6
};
export function isIconName(token) {
  if (typeof token !== 'string') return false;
  return Object.keys(iconMap).includes(token);
}
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
    scale = props.scale,
    size = props.size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Glyph = iconMap[name];
  var hasScale = scale !== null && scale !== undefined;
  var fallbackSize = size ? sizeMap[size] : 1;
  if (!Glyph) {
    return null;
  }
  return /*#__PURE__*/_jsx(Glyph, _objectSpread({
    ref: ref,
    scale: hasScale ? scale : fallbackSize
  }, otherProps));
});
Icon.displayName = 'Icon';
export default Icon;